import React, { useState, useEffect } from 'react'
import { valuationStatus } from '@utils/valuationStatus'
import { manageTooltips } from '@services/tooltip'
import { getUserInfo } from '@services/auth'
import { getAllCategoriesAsArray } from '@utils/category'
import {
  BodyText,
  HeaderActionIconWrapper,
  Pill,
  Item,
  Footer,
  Body,
  BodyItem,
  UserWrapper,
  UserIcon,
  Header,
  PinWrapper,
  ItemGroup,
  HeaderActionsWrapper,
  ViewRealty,
  ErrorItem,
  FooterSeparator,
} from './styles'
import { Pin, Arrow, OutIcon } from '@icons'

const DISABLED_STATUS = [0, 1, 3]

const ValuationItem = ({ valuation, setSelectedValuationId }) => {
  const [active, setActive] = useState(false)
  const user = getUserInfo().name
  const isInternalError =
    valuation.error && valuation.error !== 'Anúncios insuficientes'
  const disabled = DISABLED_STATUS.includes(valuationStatus[valuation.status])
  const categories = getAllCategoriesAsArray()
  useEffect(manageTooltips, [active])

  const renderError = internalError => {
    return (
      <ItemGroup>
        <ErrorItem internalError={internalError}>
          {internalError ? (
            <>
              <h3>Problemas Operacionais</h3>
              <br />
              <p>
                Favor entre em contato conosco através do e-mail
                contato@eemovel.com.br
              </p>
            </>
          ) : (
            <>
              <h3>Amostra Insuficiente</h3>
              <br />
              <p>
                Considere alterar os parâmetros utilizados para tornar a
                avaliação mais abrangente.
              </p>
              <p>
                Para mais informações, acesse nosso{' '}
                <a
                  target="_blank"
                  href="https://faq.eemovel.com.br/category/avaliacao/"
                >
                  <b>FAQ.</b>
                </a>
              </p>
            </>
          )}
        </ErrorItem>
      </ItemGroup>
    )
  }

  const renderBody = ({
    radius,
    suites,
    bedrooms,
    garages,
    subCategory,
    error,
  }) => {
    const subCategories = (isFinite(subCategory[0])
      ? subCategory.map(
          item =>
            categories.find(x => Number(x.value) === Number(item)).prettyName,
        )
      : subCategory
    ).join(', ')
    return (
      <Body>
        <ItemGroup>
          <BodyItem>
            <p>
              <b>Raio</b>
            </p>
            <p>{radius}m</p>
          </BodyItem>
          <BodyItem>
            <p>
              <b>Quartos</b>
            </p>
            <p>{(bedrooms >= 0 && bedrooms) || 'N/A'}</p>
          </BodyItem>
          <BodyItem
            hideTextOverflow
            className="tooltiped"
            data-text={subCategories}
          >
            <p>
              <b>Categorias</b>
            </p>
            <p>{subCategories || 'N/A'}</p>
          </BodyItem>
          <BodyItem>
            <p>
              <b>Suites</b>
            </p>
            <p>{(suites >= 0 && suites) || 'N/A'}</p>
          </BodyItem>
          <BodyItem>
            <p>
              <b>Garagem</b>
            </p>
            <p>{(garages >= 0 && garages) || 'N/A'}</p>
          </BodyItem>
        </ItemGroup>
        {error && renderError(isInternalError)}
        <FooterSeparator />
        <Footer>
          <UserWrapper>
            <UserIcon>{user[0]}</UserIcon>
            {user}
          </UserWrapper>
          <ViewRealty
            disabled={disabled}
            title="Ver"
            onClick={() => !disabled && setSelectedValuationId(valuation.id)}
          >
            <p>Visualizar</p>
            <OutIcon />
          </ViewRealty>
        </Footer>
      </Body>
    )
  }

  return (
    <Item active={active}>
      <Header active={active}>
        <PinWrapper>
          <Pin pinOnly width={16} height={34} />
        </PinWrapper>
        <BodyText>
          <p>
            <b>{valuation.fullAddress}</b>
          </p>
          <p>{`Área: ${valuation.area}, margem ${valuation.areaPercentMargin}%${
            valuation.sqrMeterPrice
              ? `, Valor m²: R$ ${valuation.sqrMeterPrice}, margem ${valuation.pricePercentMargin}`
              : ''
          }`}</p>
        </BodyText>
        <HeaderActionsWrapper>
          <Pill
            status={valuationStatus[valuation.status]}
            isInternalError={isInternalError}
          >
            {valuation.status}
          </Pill>
          <HeaderActionIconWrapper onClick={() => setActive(!active)}>
            <Arrow up={active} height={16} width={16} />
          </HeaderActionIconWrapper>
        </HeaderActionsWrapper>
      </Header>
      {active && renderBody(valuation)}
    </Item>
  )
}

export default ValuationItem
